<template>
  <div class="home">
    <div class="banner">
      <img src="../asset/aike/abanner.png" alt="">
    </div>
    <div class="navList wow fadeInUp" id="top1">
      <div class="itembox" v-for="(item,index) in $t('about').navList" :key="index">
      <div  class="item" :class="{active:select===index}" @click="change(index)">
         <span>
           <a>{{item}}</a>
           <svg  viewBox="0 0 21.5 21.51" class="corner top-right">
             <path  d="M21 21.51V.5H0"></path>
           </svg>
           <svg  viewBox="0 0 21.51 21.5" class="corner top-left">
             <path data-v-67ac17e6="" d="M21.51.5H.5v21">
             </path></svg>
           <svg viewBox="0 0 21.51 21.5" class="corner bottom-right">
             <path d="M0 21h21V0"></path>
           </svg>
           <svg  viewBox="0 0 21.5 21.51" class="corner bottom-left">
             <path  d="M.5 0v21h21"></path>
           </svg>
         </span>
      </div>
      </div>
    </div>
<!--    集团介绍-->
    <div class="intro" id="div1">
      <p class="title wow fadeInUp">{{$t('about').intro.text0}}</p>
      <div class="content">
       <div class="left wow fadeInLeft">
         <div class="abg">
           <img src="../asset/aike/abg.png" alt="">
         </div>
          <div class="t1">
            <!-- <div class="spic">
              <img src="../asset/aike/kp.png" alt="">
            </div> -->
            <p>{{$t('about').intro.text1}}</p>
          </div>
         <div class="t2">
           {{$t('about').intro.text2}}
         </div>
         <!-- <div class="t1">
           <div class="spic">
             <img src="../asset/aike/js.png" alt="">
           </div>
           <p>{{$t('about').intro.text3}}</p>
         </div>
         <div class="t2">
           {{$t('about').intro.text4[0]}}<br>
           {{$t('about').intro.text4[1]}}
         </div>
         <div class="t1">
           <div class="spic">
             <img src="../asset/aike/ls.png" alt="">
           </div>
           <p>{{$t('about').intro.text5}}</p>
         </div>
         <div class="t2">
           {{$t('about').intro.text6[0]}}<br>
           {{$t('about').intro.text6[1]}}<br>
           {{$t('about').intro.text6[2]}}

         </div>
         <div class="t1">
           <div class="spic">
             <img class="sp" src="../asset/aike/yj.png" alt="">
           </div>
           <p>{{$t('about').intro.text7}}</p>
         </div>
         <div class="t2">
           {{$t('about').intro.text8}}
         </div> -->
       </div>
        <div class="right wow fadeInRight" :class="{en_right:$i18n.locale=='en'}">
          <div class="allNums" ref="counts">
            <div class="item">
              <div class="pic">
                <img src="../asset/aike/country.png" alt="">
              </div>
              <p class="t2">
                <span id="num1">20</span><span class="plus">+</span>
               </p>
              <p class="t3">{{$t('about').intro.allNums[0]}}</p>
            </div>
            <div class="item">
              <div class="pic">
                <img src="../asset/aike/company.png" alt="">
              </div>
              <p class="t2">
                <span id="num2"></span><span class="plus">+</span>
              </p>
              <p class="t3">{{$t('about').intro.allNums[1]}}</p>
            </div>
            <div class="item">
              <div class="pic">
                <img v-if="$i18n.locale=='en'" src="../asset/aike/wealth3.png" alt="">
                <img v-else src="../asset/aike/wealth.png" alt="">
              </div>
              <p class="t2">
                <span id="num3">120</span><span class="plus">+</span><span class="yi">{{ $t("about").intro.allNums[3] }}</span></p>
              <p class="t3">{{$t('about').intro.allNums[2]}}</p>
            </div>
            <!-- <div class="item">
              <div class="pic">
                <img src="../asset/aike/wx.png" alt="">
              </div>
              <p class="t2">
                <span id="num4">4</span>s
              </p>
              <p class="t3">{{$t('about').intro.allNums[3]}}</p>
            </div>
            <div class="item">
              <div class="pic">
                <img src="../asset/aike/f.png" alt="">
              </div>
              <p class="t2">
                <span id="num5">100</span>°C</p>
              <p class="t3">{{$t('about').intro.allNums[4]}}</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>

<!--    发展历程-->
    <!-- <history id="div2" :development="data.development"></history> -->

<!--    集团品牌-->
    <brand id="div3" :brand="data.brand"></brand>

<!--    荣誉资质-->
    <!-- <honor id="div4" :certificate="data.certificate"></honor> -->

    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/foot.vue";
// import history from "@/components/history.vue";
import brand from "@/components/brand.vue";
// import honor from "@/components/honor.vue";
import { WOW } from "wowjs";
import { CountUp } from 'countup.js'
import Scrollbar from 'smooth-scrollbar';
import {getAbout} from "../util/lang";

export default {
  name: "home",
  data() {
    return {
      select:0,
      data:'',
      navList:[
              "集团介绍",
              "集团品牌",
      ],
      scrollbar:''
    };
  },
  mounted() {
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
    this.scrollbar.scrollTo(0, 1);
    this.scrollbar.addListener((status) => {
      window.pageYOffset = this.scrollbar.scrollTop;
    });
    setTimeout(()=>{
      if (window.location.search.replace("?", "").split("=")[1] !== undefined){
        this.change(parseInt(this.getNid()))
      }else{
        Scrollbar.get(
                document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#top1"), {
          offsetTop: 170
        });
      }
      this.getContent()
      this.count()
    },100)
  },
  components: {foot,brand},
  methods:{
    getContent(){
      const url = `${getAbout()}`
      this.$axios.get(url).then(res => {
        this.data=res.data
      })
    },
    getNid() {
      return window.location.search
              .replace("?", "")
              .split("=")[1]
              .split("?")[0];
    },
    change(n){
     this.select=n
      if(n===0){
        Scrollbar.get(
                document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#div1"), {
          offsetTop: 120
        });
      }else if(n===1){
        Scrollbar.get(
                document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#div3"), {
          offsetTop: 120
        });
      }
    },
    count(){
      let element=this.$refs.counts;
      let actualTop = element.offsetTop;
      let current = element.offsetParent;
      while (element=element.offsetParent){
        actualTop += element.offsetTop;
        /* current = current.offsetParent; */
      }
      let demoFi1 = new CountUp("num1", 130);
      let demoFi2 = new CountUp("num2", 49);
      let demoFi3
      if (this.$i18n.locale == "en") {
        demoFi3 = new CountUp("num3", 200);
      } else {
        demoFi3 = new CountUp("num3", 35);
      }
      // let demoFi4 = new CountUp("num4", 4);
      // let demoFi5 = new CountUp("num5", 100);
      // demoFi1.start();
      // demoFi2.start();
      // demoFi3.start();
      let numok=false;
      let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
      if(scrollbar){
        scrollbar.addListener((status) => {
          if(!numok){
            if(actualTop<status.offset.y+document.body.clientHeight){
              demoFi1.start();
              demoFi2.start();
              demoFi3.start();
              // demoFi4.start();
              // demoFi5.start();
              numok=true;
            }
          }
        });
      }
    },
  }
};
</script>
<style  lang="scss" scoped>
.home{
  width:100%;
  .banner{
    width:100%;
    height:100vh;
    overflow: hidden;
    img{
      width:100%;
      display: block;
      object-fit: cover;
      height:100%;
      animation: sbig 5s linear forwards;
    }
    @keyframes sbig {
      from{
        transform: scale(1);
      }
      to{
        transform: scale(1.05);
      }
    }
  }
  .navList{
    width:77%;
    margin: 0 auto;
    border-bottom: 1px solid #F5F5F5;
    justify-content: center;
    display: flex;
    flex-direction: row;
    animation-duration: 2s;
    .itembox{
      width: 50%;
      display: flex;
      justify-content: center;
    }
    .item{
      display: inline-block;
      text-align: center;
      overflow: hidden;
      margin: 0 80px;
      transition: all 600ms;
      span{
        text-align: center;
        width: 400px;
        display: inline-block;
        height: 75px;
        line-height:75px;
        color:#666666;
        font-family: "SOURCEHANSANSCN-NORMAL";
        cursor: pointer;
        position: relative;
        -webkit-transition: all 2s;
        transition: all 2s;
        a{
          position: absolute;
          width: 100%;
          left: 0;
          transition: all 600ms;
        }
        .corner{
          width: 10px;
          height: 10px;
          opacity: 0;
          path{
            fill: none;
            stroke: #019bdb;
            stroke-width: 2;
          }
        }
        .top-right{
          position: absolute;
          top: -20px;
          right: -20px;
          transition: top .3s,right .3s;
        }
        .top-left{
          position: absolute;
          top: -5px;
          left: -5px;
          transition: top .3s,left .3s;
        }
        .bottom-right{
          position: absolute;
          bottom: -5px;
          right: -5px;
          transition: bottom .3s,right .3s;
        }
        .bottom-left{
          position: absolute;
          bottom: -5px;
          left: -5px;
          transition: bottom .3s,left .3s;
        }
        &:hover{
          .corner{
            opacity: 1;
          }
          .top-right{
            top: 10px;
            right:10px;
          }
          .top-left{
            top: 10px;
            left: 10px;
          }
          .bottom-right{
            bottom:10px;
            right: 10px;
          }
          .bottom-left{
            bottom: 10px;
            left: 10px;
          }
        }
      }
    }
    .active{
      background-color: #019bdb;
      span{
        a{
          color:white;
        }
      }
    }
  }
  .intro{
    width:60%;
    margin: 60px auto;
    .title{
      text-align: center;
      color:#343434;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-MEDIUM";
      animation-duration: 2s;
    }
    .content{
      width:100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 60px;
      .left{
        width:100%;
        position: relative;
        animation-duration: 2s;
        .abg{
          position: absolute;
          left:50%;
          transform: translateX(-50%);
          top:15%;
          max-width: 100%;
          z-index: -1;
          img{
            max-width: 100%;
          }
        }
        .t1{
          width:100%;
          display: flex;
          flex-direction: row;
          align-self: center;
          justify-content: center;
          p{
            font-family: "SOURCEHANSANSCN-MEDIUM";
            font-size: 22px;
          }
        }
        .t1{
          .spic{
            .sp{
              padding-top: 7px;
            }
          }
        }
        .t2{
          font-size: 20px;
          color:#343434;
          line-height: 40px;
          font-family: "SOURCEHANSANSCN-NORMAL";
          margin: 20px 0 40px 0;
          text-align: center;
        }
      }
      .right{
        width:100%;
        animation-duration: 2s;
        .allNums{
          display: flex;
          // flex-direction: column;
          align-items: center;
          width:100%;
          height:100%;
          justify-content: space-between;
          .item{
            // width:25%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            .pic{
              img{
                transition: all 600ms;
                cursor: pointer;
                &:hover{
                  transform: rotateY(360deg);
                }
              }
            }
            .t2{
              font-size: 20px;
              font-family: "ITCAvantGardeStd-Bold";
              font-weight: bolder;
              color:#0C4EA2;
              line-height: 100px;
              height: 50px;
              line-height:50px;
              margin: 15px 0;
              .plus{
                margin-top: -20px;
                font-size: 35px;
              }
              .yi{
                font-size: 25px;
              }
              span{
                font-size: 50px;
              }
            }
            .t3{
              color:#343434;
              font-family: "SOURCEHANSANSCN-NORMAL";
            }
          }
          .item:nth-child(2){
            width: 50%;
            border: 1px solid rgba(0,0,0,.1);
            border-width: 0 1px 0 1px;
          }
          // .item:nth-child(3){
          //   align-items: flex-end;
          // }
        }
      }
      .en_right{
        .allNums{
          .item{
            width: 33%;
            .t3{
              height: 32px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width:1000px){
    .navList{
      width: 100%;
      flex-wrap: wrap;
      .item{
        margin: 0 10px;
        span{
          width: 100px;
        }
      }
    }
    .intro{
      width:90%;
      margin: 30px auto;
      .title{
        font-size: 24px;
      }
      .content{
        margin-top: 30px;
        flex-direction: column;
        .left{
          .t2{
            margin: 15px 0;
            font-size: 18px;
            line-height: 35px;
          }
        }
        .right{
          .allNums{
        width: 100%;
        margin-top: 50px;
        .item{
          width: 33.333%;
          .pic{
            img{
              width: 80%;
              margin-left: 10%;
            }
          }
          .t2{
            font-weight: unset;
            margin: unset;
            span{
              font-size: 25px;
              font-family: 'it';
              font-weight: bold;
              // color: white;
            }
            .plus{
              font-size: 16px;
              margin-left: 5px;
              font-weight: bold;
            }
            .yi{
              font-size: 25px;
              font-weight: lighter;
            }
          }
          .t3{
            font-size: 14px;
            text-align: center;
            height: 28px;
          }
        }
      }
        }
        .en_right{
          .allNums{
            .item{
              .t2{
                span{
                  font-size: 16px;
                }
                .yi{
                  font-size: 16px;
                }
              }
              .t3{
                font-size: 12px;
              }
            }
          }
        }
        .left,.right{
          width:100%;
        }
      }
    }
  }
}
</style>

